import { previewActions } from "../action/types";

const initialState = {
	isPreview: false,
	previewData: null,
};

const bannerPreviewReducer = (state = initialState, action) => {
	switch (action.type) {
		case previewActions.BANNER_PREVIEW_ADD: {
			const {  previewData } = action.payload;
			const object = {
                ...state,
				isPreview: true,
				previewData,
            }
			return object;
		}
		case previewActions.BANNER_PREVIEW_CLEAR: {
			const object = {
                ...state,
				isPreview: false,
				previewData: null,
            }
			return object;
		}

		default:
			return state;
	}
};

export default bannerPreviewReducer;